import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import theme from 'src/theme';
import { ReactComponent as AddPaymentMethodIcon } from 'src/assets/icons/add-payment-method.svg';

export const StyledBillingIconButton = styled(IconButton)({
    padding: '4px',
    color: 'inherit',
    '&:hover:not(:disabled)': {
        backgroundColor: theme.color.lightOrangeYellow
    },
    '&:disabled': {
        cursor: 'not-allowed'
    }
});

export const StyledBillingIcon = styled(AddPaymentMethodIcon)({
    width: 30,
    height: 30,
    display: 'block'
});
